import { useEffect, useState } from "react"
import { getProvinciaById, postProvincia, patchProvincia} from "../../services/ProvinciasServices"
import { ProvinciasFormContext } from "./ProvinciasContext"
import { useNavigate, useParams } from 'react-router-dom';

export const ProvinciasFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getProvinciaByIdData(id)
    }, [])

    const getProvinciaByIdData = async (id) => {
        let res = await getProvinciaById(id)
        if (res) setReport(res)
    }

    const postProvinciaData = async (body) => {
        const res = await postProvincia(body)
        if (res) navigate("/provincias");
    }

    const patchProvinciaData = async (id, body) => {
        const res = await patchProvincia(id, body)
        if (res) navigate("/provincias");
    }

    return <ProvinciasFormContext.Provider value={{
        report,
        postProvinciaData,
        patchProvinciaData,
    }} >
        {children}
    </ProvinciasFormContext.Provider>
}